import { Locale } from '@headless-workspace/config';
import {
    ConfigByKeyRepository,
    Result,
    ResultSuccess,
    unwrapSettledResultSuccess,
} from '@headless-workspace/core-domain';
import { LanguageHelpers } from '@headless-workspace/utils';
import { z } from 'zod';

const ENABLED_SWOGO_CONFIG_KEY = 'enableSwogo';
const COUNTRIES_ENABLED_SWOGO_CONFIG_KEY = 'countriesEnabledSwogo';

export interface CrossSellsBundlesConfigRepositorySpec {
    isEnabled(locale: Locale): Promise<Result<boolean>>;
}

export class CrossSellsBundlesConfigRepository
    extends ConfigByKeyRepository
    implements CrossSellsBundlesConfigRepositorySpec
{
    async isEnabled(locale: Locale): Promise<Result<boolean>> {
        const [enabledSwogoConfigResult, countriesEnabledSwogoConfigResult] = await Promise.allSettled([
            this.getConfigByKey(ENABLED_SWOGO_CONFIG_KEY, { locale }, (value) => z.boolean().parse(value)),
            this.getConfigByKey(COUNTRIES_ENABLED_SWOGO_CONFIG_KEY, { locale }, (value) =>
                z.array(z.string()).parse(value),
            ),
        ]);
        const country = LanguageHelpers.parseCountry(locale);
        const enabledSwogoConfig = unwrapSettledResultSuccess(enabledSwogoConfigResult);
        const countriesEnabledSwogoConfig = unwrapSettledResultSuccess(countriesEnabledSwogoConfigResult);

        const isCrossSellsEnabled = !!enabledSwogoConfig && !!countriesEnabledSwogoConfig?.includes(country);

        return ResultSuccess(isCrossSellsEnabled);
    }
}
